module.exports = __webpack_public_path__ + "media/images/carousel/banner_1-c752cee7ab916a83432817e6219de2d3.jpg";